<template>
  <div class="app-tab-bar">
    <!-- 下方导航 -->
    <van-tabbar v-model="active"
      active-color="#2f54eb"
      inactive-color="#000"
      @change="onChange"
      shape="round"
      route>
      <van-tabbar-item icon="home-o"
        to="/index">首页</van-tabbar-item>
      <van-tabbar-item icon="shopping-cart-o"
        to="/order">订单</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "app-tab-bar",
  data() {
    return {
      active: 1
    }
  },
  methods: {
    onChange(m) {
      this.active = m
    },
  },
}
</script>

<style>
</style>